import React from "react";
import { createAccountingSidebarConfig } from "../../../../components/UnifiedSidebar/ConfigExamples";
import { UnifiedSidebar } from "../../../../components/UnifiedSidebar/UnifiedSidebar";

interface SidebarProps {
  drawerWidth: number;
  mobileOpen: boolean;
  onDrawerToggle: () => void;
  onLogout: () => void;
  currentPath: string;
}

export const Sidebar: React.FC<SidebarProps> = ({
  drawerWidth,
  mobileOpen,
  onDrawerToggle,
  onLogout,
  currentPath,
}) => {
  // Create the sidebar configuration for accounting module
  const sidebarConfig = React.useMemo(() => {
    const config = createAccountingSidebarConfig();
    // Override the default width with the provided drawerWidth
    return {
      ...config,
      defaultWidth: drawerWidth,
    };
  }, [drawerWidth]);

  return (
    <UnifiedSidebar
      config={sidebarConfig}
      currentPath={currentPath}
      mobileOpen={mobileOpen}
      onDrawerToggle={onDrawerToggle}
      onLogout={onLogout}
    />
  );
};
